import History from 'components/Home/History';
import Cookies from 'js-cookie';
import { useAppDispatch, useAppSelector } from 'reducer';
import { bottomDrawer, hideDrawer } from 'reducer/slices/drawerSlice';
import utils from 'tools/utils';

const Profile = () => {
  const dispatch = useAppDispatch();
  const useUser = useAppSelector((state) => state.user);

  const logout = async () => {
    Cookies.set('refreshToken', '');
    Cookies.set('accessToken', '');
    window.location.reload();
  };

  return (
    <div className='popup_page contain_center'>
      <div className='back_to_main' onClick={() => dispatch(hideDrawer())}>
        <div className='back_icon'></div>
      </div>
      <h3>پروفایل</h3>
      <div className='form'>
        <div className='inp_top'>
          <span>خوش آمدید</span>
          <p>{useUser.profile.email}</p>
          <br />
          <br />
          <span>موجودی:</span>
          <p>{utils.formatter(useUser.profile.balanceAmount)} هات ووچر</p>
          <br />
          <br />
          <span
            onClick={() => {
              dispatch(hideDrawer());
              setTimeout(() => {
                dispatch(bottomDrawer(<History />));
              }, 500);
            }}
            style={{ cursor: 'pointer' }}
          >
            تراکنش ها و کدها
          </span>
          <br />
          <br />
          <span onClick={() => logout()} style={{ cursor: 'pointer' }}>
            خروج
          </span>
        </div>
      </div>
    </div>
  );
};

export default Profile;
